import {PureComponent} from 'react'
import PropTypes from 'prop-types'

import './IllustratedDiv.scss'

export default class IllustratedDiv extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    imgAlt: PropTypes.string.isRequired,
    imgSrc: PropTypes.string.isRequired,
    showOnMobile: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    showOnMobile: false,
  }

  render() {
    return <div className="illustrated-div row align-items-center">
      <div className="col-12 col-lg-6">
        {this.props.children}
      </div>
      <div className="col-12 col-lg-6 text-center">
        <img className="w-100" alt={this.props.imgAlt} src={this.props.imgSrc}/>
      </div>
    </div>
  }
}
